import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"
import { RoleType } from "utils/constants"

interface ResultsDataBase {
    clientToken?: string
    psyToken?: string
    role?: RoleType
}

interface DataWithMeta {
    data: ResultsDataBase
    expiry: number
}

export class ChatStorage {
    private static readonly storage = isStorageAvailable
        ? new StorageWrapper(window.localStorage)
        : undefined

    private static readonly STORAGE_KEY = "chat"

    private static readonly MAX_AGE_MS = 5 * 60 * 1000

    static get(): ResultsDataBase {
        const date = Date.now()
        const data = this.storage?.getObject<DataWithMeta>(this.STORAGE_KEY)

        if (data && data.expiry > date) {
            return data.data
        }

        return {}
    }

    static set(data: ResultsDataBase): void {
        const currentData = this.get()
        const updatedData = { ...currentData, ...data }
        const expiry = Date.now() + this.MAX_AGE_MS
        const dataWithMeta: DataWithMeta = { data: updatedData, expiry }
        this.storage?.storeObject(this.STORAGE_KEY, dataWithMeta)
    }
}
